import { DetailsFaq } from '@components/details-faq/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const detailsFaqMock: Block<DetailsFaq> = {
  type: 'details-faq',
  data: {
    question: 'Quelles sont les garanties sur ma cuisine ?',
    answer: `Sur notre <b>qualité</b>, zéro compromis !<br />C’est pourquoi, nous garantissons : les meubles de cuisine et leurs mécanismes <b>5 ans</b> (hors équipements électriques, garantie 2 ans), les charnières et coulisses <b>25 ans</b>, les appareils électroménagers encastrables <b>2 ans</b>, les éviers, mitigeurs, tables, chaises et tabourets <b>2 ans</b>, et les accessoires <b>1 an</b>.<br />Bien sûr, votre cuisine est <b>garantie</b>, que vous la posiez vous-même ou qu’elle soit posée par un poseur SoCoo’c.`,
    backUrl: '/mock-faq-listing',
    image: imageMock,
    category: 'Mon Budget',
  },
};
